import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// bloccoFatture: messaggio 409 dal backend -> mostra la seconda conferma (force)
export function ConfermaEliminaCommessa({ open, onOpenChange, onConfirm, loading, bloccoFatture }) {
  const seconda = !!bloccoFatture;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={seconda ? "conferma-elimina-fatturata" : "conferma-elimina-commessa"}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">
            {seconda ? "Commessa con fatture emesse" : "Elimina commessa"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {seconda ? (
              <>
                <span className="block text-red-700 font-medium mb-1">{bloccoFatture}</span>
                Confermi come amministratore di voler spostare comunque la commessa e le sue fatture nel cestino?
              </>
            ) : (
              "Sei sicuro di voler eliminare questa commessa? L'operazione non può essere annullata."
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="elimina-commessa-annulla">Annulla</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm(seconda);
            }}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid={seconda ? "elimina-commessa-conferma-forzata" : "elimina-commessa-conferma"}
          >
            {loading ? "Eliminazione…" : seconda ? "Sì, elimina comunque" : "Elimina"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
